import { createContext, useContext, useMemo, } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getFooter, addFooter, updateFooter } from "../../api/footer";
import useToaster from "../../components/alert";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const getFooterQuery = useQuery({
    queryKey: ["contact-us"],
    queryFn: getFooter,
  });

  const addFooterQuery = useMutation({ mutationFn: addFooter });
  const updateFooterQuery = useMutation({ mutationFn: updateFooter });
  const toaster = useToaster();

  const initialValues = useMemo(() => {
    const footerData = getFooterQuery?.data?.data?.[0] || {};

    return {
      heading: footerData.heading || "",
      sub_heading: footerData.sub_heading || "",
      cta_label: footerData.cta_label || "",
      cta_redirect_link: footerData.cta_redirect_link || "",
      socials: {
        heading: footerData?.socials?.heading || "",
        sub_heading: footerData?.socials?.sub_heading || "",
        socials: footerData?.socials?.socials?.map((social) => ({
          heading: social.heading || "",
          link: social.link || "",
          logo: social.logo || "",
        })) || [{ heading: "", sub_heading: "", logo: "" }],
      },
      business_details: {
        heading: footerData?.business_details?.heading || "",
        email: footerData?.business_details?.email || "",
        contact: footerData?.business_details?.contact || ""
      },
      quick_links_details: {
        heading: footerData?.quick_links_details?.heading || "",
        quick_links: footerData?.quick_links_details?.quick_links || [
          {
            label: "",
            redirect_link: "",
          },
        ],
      },
      address_details: {
        title: footerData?.address_details?.title || "",
        address: footerData?.address_details?.address || "",
      },
    };
  }, [getFooterQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      heading: values.heading,
      sub_heading: values.sub_heading,
      cta_label: values.cta_label,
      cta_redirect_link: values.cta_redirect_link,
      socials: {
        heading: values.socials.heading,
        sub_heading: values.socials.sub_heading,
        socials: values.socials.socials,
      },
      business_details: {
        heading: values?.business_details?.heading || "",
        email: values?.business_details?.email || "",
        contact: values?.business_details?.contact || ""
      },
      quick_links_details: {
        heading: values?.quick_links_details?.heading || "",
        quick_links: values?.quick_links_details?.quick_links?.map(item => ({
          label: item.label,
          redirect_link: item?.redirect_link
        })),
      },
      address_details: {
        title: values?.address_details?.title || "",
        address: values?.address_details?.address || "",
      },
    };

    const footerData = getFooterQuery?.data?.data?.[0] || {};
    if (footerData._id) {
      payload.id = footerData._id;
      updateFooterQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success("Success", "Data is updated successfully.");
        },
      });
    } else {
      addFooterQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success("Success", "Data is added successfully.");
        },
      });
    }
  };

  return <PageContext.Provider value={{ initialValues, handleSubmit }}>{children}</PageContext.Provider>;
};

export const useFooterProvider = () => useContext(PageContext);
